module.exports = __webpack_public_path__ + "static/img/designGuideBanner.0ff7991.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/designGuideBanner.png
// module id = Ok/C
// module chunks = 2